import { render, staticRenderFns } from "./NewSupervision.vue?vue&type=template&id=6834762e&scoped=true"
import script from "./NewSupervision.vue?vue&type=script&lang=js"
export * from "./NewSupervision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834762e",
  null
  
)

export default component.exports